const PresetDocumentLabels = {
  PASSPORT: "Passport Main Photo Page",
  DRIVER_LICENSE_FRONT: "Driver License Front",
  DRIVER_LICENSE_BACK: "Driver License Back"
};
export default PresetDocumentLabels;

export const PresetDocumentLabelIcons = {
  [PresetDocumentLabels.PASSPORT]: "passport",
  [PresetDocumentLabels.DRIVER_LICENSE_FRONT]: "account-card-details-outline",
  [PresetDocumentLabels.DRIVER_LICENSE_BACK]: "account-card-details-outline"
};
